module.exports = __webpack_public_path__ + "static/media/calendar_01.126a940c.png";